type Props = {
  firstName?: string | null;
  lastName?: string | null;
  teamName?: string;
  teamAlias?: string | null;
};

export const formatDisplayName = ({
  firstName,
  lastName,
  teamName,
  teamAlias,
}: Props) => {
  const fullName = `${firstName ?? ''} ${lastName ?? ''}`.trim();
  const teamSuffix = teamAlias ?? teamName;

  if (teamSuffix) {
    return `${fullName} - ${teamSuffix}`;
  }

  return fullName;
};
